export default function ezpass() {
    return (
        <>
            <div className="min-h-0 flex-1">
                <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", flexDirection: "row", flex: "1" }}>
                        <iframe
                            src="http://159.89.43.23/"
                            allow=""
                            height={"100%"}
                            style={{ flex: "1", borderRadius: "1rem" }}
                            seamless
                            title="ezpass"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
